import React, { useMemo } from 'react';
import { Box, Typography } from '@material-ui/core';
import { useDropzone } from 'react-dropzone';
import { CloudUpload } from '@material-ui/icons';
import { useDispatch } from 'react-redux';
import { setPosterProps } from 'redux/actions/Movies';

const maxSize = 30 * 1024 * 1024; // 30 MB

const baseStyle = {
  flex: 1,
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  padding: '100px 20px',
  borderWidth: 2,
  borderRadius: 2,
  borderColor: '#eeeeee',
  borderStyle: 'dashed',
  backgroundColor: '#A1A8E866',
  color: 'white',
  outline: 'none',
  transition: 'border .24s ease-in-out',
};

const activeStyle = {
  borderColor: '#2196f3',
};

const acceptStyle = {
  borderColor: '#00e676',
};

const rejectStyle = {
  borderColor: '#ff1744',
};

const thumbsContainer = {
  display: 'flex',
  flexDirection: 'row',
  flexWrap: 'wrap',
  marginTop: 16,
};

const thumb = {
  display: 'inline-flex',
  borderRadius: 2,
  border: '1px solid #eaeaea',
  marginBottom: 8,
  marginRight: 8,
  width: 100,
  height: 100,
  padding: 4,
  boxSizing: 'border-box',
};

const thumbInner = {
  display: 'flex',
  minWidth: 0,
  overflow: 'hidden',
};

const img = {
  display: 'block',
  width: 'auto',
  height: '100%',
};

const UploadPosterDropZone = () => {
  const [files, setFiles] = React.useState([]);

  const dispatch = useDispatch();
  const onDrop = acceptedFiles => {
    setFiles(
      acceptedFiles.map(file =>
        Object.assign(file, {
          preview: URL.createObjectURL(file),
        }),
      ),
    );
    dispatch(setPosterProps(acceptedFiles[0]));
  };

  const { getRootProps, getInputProps, isDragActive, isDragAccept, isDragReject, rejectedFiles } = useDropzone({
    accept: 'image/*',
    onDrop,
    maxSize,
  });

  const isFileTooLarge = rejectedFiles?.length > 0 && rejectedFiles[0]?.size > maxSize;

  const style = useMemo(
    () => ({
      ...baseStyle,
      ...(isDragActive ? activeStyle : {}),
      ...(isDragAccept ? acceptStyle : {}),
      ...(isDragReject ? rejectStyle : {}),
    }),
    [isDragActive, isDragReject, isDragAccept],
  );

  const thumbs = files.map(file => (
    <div style={thumb} key={file.name}>
      <div style={thumbInner}>
        <img src={file.preview} style={img} alt="" />
      </div>
    </div>
  ));

  React.useEffect(
    () => () => {
      files.forEach(file => URL.revokeObjectURL(file.preview));
    },
    [files],
  );

  return (
    <Box>
      <Box {...getRootProps({ style })}>
        <input {...getInputProps()} />
        <CloudUpload style={{ fontSize: 72 }} />
        <Typography>انتخاب پوستر</Typography>
        {isFileTooLarge && <Typography color="red">بیشتر از 30 مگابایت مجاز نیست</Typography>}
      </Box>
      <aside style={thumbsContainer}>{thumbs}</aside>
    </Box>
  );
};

export default UploadPosterDropZone;
